import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { Button } from 'components/form/Button';
import { PageContainer } from 'components/Containers/PageContainer/PageContainer';
import classnames from 'classnames';
import { ShowtotalCostTerm } from 'partial/OfferManager/modules/PersonalLoanPrequalResultModule/PersonalLoanPrequalResultModuleView';
import { commafy } from 'helpers/number';
import { PREQUALMODULE_SUBHEADER } from 'global_types/mrph.module.constants';

const PlPrequalOfferModuleView = ({
  prequalOffers,
  pagePosition,
  modulePosition,
  onClickSeeMoreOffers,
  seenPixel,
  isActionsModule,
  ...props
}) => {
  let prequalOffer = prequalOffers.slice(0, 1);
  let labelText = `Here’s your top pre-qualified ${commafy(
    prequalOffer.loanAmount,
  )} loan
  offer`;
  let subLabelText;

  if (isActionsModule) {
    prequalOffer = prequalOffers.slice(0, 3);
    labelText = 'You’re pre-qualified for the following personal loan offers';
    subLabelText = PREQUALMODULE_SUBHEADER;
  }

  const titleClass = classnames('m-margB16', {
    margB32: !subLabelText,
    margB16: subLabelText,
  });

  return (
    <>
      {seenPixel}
      <PageContainer className="CreditLimitView">
        <SectionContainer className="plPrequalOfferModule padB40 m-padB16">
          <Row>
            <Label type="H3" typeHeader={'h3'} className={titleClass}>
              {labelText}
            </Label>
            {subLabelText && (
              <Label
                type="Body-1"
                className="margB24 m-text-14"
                datatestid={'prequalmodule-subHeader'}
              >
                {subLabelText}
              </Label>
            )}
            <div className="prequalOfferContainer margB8">
              <StaticOfferContainer
                eventHandler={props.eventHandler}
                offerMetadataList={prequalOffer}
                pagePosition={pagePosition}
                modulePosition={modulePosition}
              />
            </div>
            <div className="text-center">
              <Button mrphType="link" onClick={onClickSeeMoreOffers}>
                See more pre-qualified offers
              </Button>
            </div>
          </Row>
        </SectionContainer>
        <ShowtotalCostTerm className={'margT32 margB20 m-margB32 m-margLR16'} />
      </PageContainer>
    </>
  );
};

export { PlPrequalOfferModuleView };
